import { AnyAction } from 'redux';

import * as constants from 'redux/constants/permissions.constants';
import { ITableUpdate } from 'types/table.types';
import { IPermissionsFormData } from 'views/PermissionsView/components/PermissionsForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.PERMISSIONS_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.PERMISSIONS_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.PERMISSIONS_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IPermissionsFormData, id?: string): AnyAction => ({
  type: constants.PERMISSIONS_ON_SAVE_REQUESTED,
  formData,
  id,
});
